module.exports = __webpack_public_path__ + "img/carry.5c7c9918.svg";